"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _formik = require("formik");

var yup = _interopRequireWildcard(require("yup"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _components = _interopRequireDefault(require("./components"));

var _yupSchemaCreator = require("./utils/yupSchemaCreator");

var _constants = require("./constants");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Button = _styledComponents.default.button`
  padding: 4px;
  width: 190px;
`;

function DynamicForm(props) {
  const {
    fields,
    cbSubmit
  } = props;
  const initialValues = {};
  fields.forEach(item => {
    initialValues[item.id] = item.value || "";
  });
  const yupSchema = fields.reduce(_yupSchemaCreator.createYupSchema, {});
  const validateSchema = yup.object().shape(yupSchema);
  return /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    initialValues: initialValues,
    validationSchema: validateSchema,
    onSubmit: cbSubmit
  }, formikProps => /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: formikProps.handleSubmit
  }, /*#__PURE__*/_react.default.createElement(_components.default, {
    fields: fields,
    formikProps: formikProps
  }), /*#__PURE__*/_react.default.createElement(Button, {
    type: "submit"
  }, "Submit")));
}

DynamicForm.propTypes = {
  fields: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    label: _propTypes.default.string,
    placeholder: _propTypes.default.string,
    type: _propTypes.default.oneOf(_constants.FIELD_TYPES).isRequired,
    validationType: _propTypes.default.oneOf(_constants.VALIDATION_TYPES).isRequired,
    value: _propTypes.default.any,
    options: _propTypes.default.array,
    validations: _propTypes.default.arrayOf(_propTypes.default.shape({
      type: _propTypes.default.string.isRequired,
      params: _propTypes.default.array.isRequired
    }))
  })).isRequired,
  cbSubmit: _propTypes.default.func.isRequired
};
var _default = DynamicForm;
exports.default = _default;